import { createClient, createConfig, } from "./client";
export const client = createClient(createConfig({
    baseUrl: "https://api.projectgotta.com",
}));
//# sourceMappingURL=client.gen.js.map